import {IDataColumn, IDataRow} from '..';

import {DataColumn} from './data-column';

export class DataRow {
    public readonly rowIndex: number;
    public readonly isMainRow: boolean;
    public readonly subRowOf: number;
    public readonly toggleable: boolean;
    public readonly checkable: boolean;
    public readonly checkableActionMenu: boolean;

    public rowId: number | string;
    public dataItems: DataColumn[];
    public disabledActions: { [key: number]: boolean };
    public toggled: boolean;
    public checked: boolean;
    public actionMenuChecked: boolean;
    public hidden: boolean;
    public hasClickableDataItem: boolean;
    public hiddenActions: { [key: number]: boolean };

    constructor(data: IDataRow) {
        this.rowId = data.rowId;
        this.rowIndex = (typeof data.rowIndex !== 'undefined') ? data.rowIndex : null;
        this.dataItems = data.dataItems.map((item: IDataColumn) => new DataColumn(item));
        this.disabledActions = !data.disabledActions ? {} : data.disabledActions;
        this.isMainRow = !!data.isMainRow;
        this.subRowOf = (typeof data.subRowOf !== 'undefined') ? data.subRowOf : null;
        this.toggleable = !!data.toggleable;
        this.toggled = !!data.toggled;
        this.checkable = !!data.checkable;
        this.checkableActionMenu = !!data.checkableActionMenu;
        this.checked = !!data.checked;
        this.actionMenuChecked = !!data.actionMenuChecked;
        this.hidden = !!data.hidden;
        this.hasClickableDataItem = !!data.hasClickableDataItem;
        this.hiddenActions = !data.hiddenActions ? {} : data.hiddenActions;
    }

    getItemByColId(id: string | number): DataColumn {
        const filteredData = this.dataItems.filter((data: DataColumn) => (data.colId === id));

        return (filteredData.length !== 0) ? filteredData[0] : null;
    }
}
